// extracted by mini-css-extract-plugin
var _1 = "Label-modulecompactLabel__Mj4B8";
var _2 = "Label-modulelabel__cjQoq Tag-moduleTag__FLr9H";
export { _1 as "compactLabel", _2 as "label" }
